/* Nav tile · sits on /division/tdb · opens the Bundle BOM screen. */
import { useEffect, useState } from 'react';
import { Package, ChevronRight, AlertTriangle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import api from '@/lib/api';


export default function TDBBundleBOMTile({ className = '' }) {
  const [summary, setSummary] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const r = await api.get('/tdb-mis/bundles');
        if (alive) setSummary(r.data?.summary);
      } catch (e) { /* tile is non-essential */ }
    })();
    return () => { alive = false; };
  }, []);

  return (
    <button
      data-testid="tdb-bundle-bom-tile"
      onClick={() => navigate('/tdb/bundles')}
      className={`w-full bg-white border border-violet-200 rounded-2xl p-4 text-left hover:bg-violet-50 transition group ${className}`}
    >
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 flex-1 min-w-0">
          <div className="w-10 h-10 rounded-lg bg-violet-100 text-violet-700 flex items-center justify-center shrink-0">
            <Package className="w-5 h-5" />
          </div>
          <div className="min-w-0">
            <div className="flex items-center gap-2 flex-wrap">
              <h3 className="text-sm font-semibold text-slate-900">
                Bundle BOM · Hampers & Combos
              </h3>
              <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-emerald-100 text-emerald-800 font-medium uppercase tracking-wider">
                Sprint E.5 · live
              </span>
              {summary?.missing > 0 && (
                <span
                  data-testid="tdb-bb-tile-missing-count"
                  className="text-[10px] px-1.5 py-0.5 rounded-full bg-amber-200 text-amber-900 font-medium flex items-center gap-1"
                >
                  <AlertTriangle className="w-3 h-3" />
                  {summary.missing} need Roji
                </span>
              )}
            </div>
            <p className="text-xs text-slate-500 mt-0.5 truncate">
              {summary
                ? `${summary.total} bundles · ${summary.complete} complete · avg margin ${summary.avg_margin_pct}%`
                : 'Live food cost for every hamper · cascades from ingredient master'}
            </p>
          </div>
        </div>
        <ChevronRight className="w-4 h-4 text-slate-400 group-hover:text-violet-700 shrink-0" />
      </div>
    </button>
  );
}
